import React from 'react'
import './DashboardCard.css'

const DashboardCard = ({ value, label }) => {
    return <div className="dashboard-card">
        <div className="dashboard-card-value">{value}</div>
        <div className="dashboard-card-label">{label}</div>
    </div>
    
}

export default DashboardCard